import _asyncToGenerator from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import providerApiService from "../../../services/api/ProviderApiService";
import PaginationTable from "../../../components/pagination-table/PaginationTable.vue";
import { convertDateToHumanReadable, getDepartmentLabel, getTicketStatus } from "../../../helpers/Functions";
export default {
  name: "CouponsList.vue",
  components: {
    PaginationTable: PaginationTable
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  methods: {
    getTickets: function getTickets(page) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return providerApiService.getProviderTickets(_this.currentProvider.id, page);

              case 3:
                result = _context.sent;
                return _context.abrupt("return", result);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    createNewTicket: function createNewTicket() {
      this.$router.push("/tickets/create");
    },
    onClickTicket: function onClickTicket(ticket) {
      this.$router.push("/tickets/".concat(ticket.id));
    },
    ticketCreated: function ticketCreated(coupon) {
      this.$refs.unlimitedListRef.createItem(coupon);
    },
    getStatus: function getStatus(value) {
      return getTicketStatus(value);
    },
    getDepartment: function getDepartment(value) {
      return getDepartmentLabel(value);
    },
    getLastTimeUpdated: function getLastTimeUpdated(value) {
      return convertDateToHumanReadable(value, true);
    }
  }
};